import React, { useState, useEffect } from "react";
import { Table, Spin, Tooltip } from "antd";
import { FaEnvelope } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./appointment.css";

const AppointmentsPage = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [appointments, setAppointments] = useState([]);
  const clientDetails = useSelector((state) => state.fetchedClient);

  useEffect(() => {
    if (clientDetails && clientDetails.appointments && clientDetails.appointments.length > 0) {
      setAppointments(clientDetails.appointments);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, [clientDetails]);

  const columns = [
    {
      title: "Client Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Practitioner Name",
      dataIndex: "doctorName",
      key: "doctorName",
    },
    {
      title: "Department",
      dataIndex: "serviceTitle",
      key: "serviceTitle",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <Tooltip title={text} style={{ height: "100%" }}>
          <div style={{ textAlign: "center", verticalAlign: "middle" }}>
            <FaEnvelope
              className="fa fa-envelope skeleton-icon"
              style={{
                fontSize: "25px",
                color: "#BDC0C3",
                cursor: "pointer",
              }}
            />
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Appointment Date",
      dataIndex: "appointmentDate",
      key: "appointmentDate",
      render: (text, record) => {
        const date = new Date(text);
        const formattedDate = date.toLocaleDateString();
        return <div>{formattedDate}</div>;
      },
    },
    {
      title: "Appointment Time",
      dataIndex: "appointmentDate",
      key: "appointmentTime",
      render: (text, record) => {
        const date = new Date(text);
        const options = { hour: "numeric", minute: "numeric" };
        const formattedTime = date.toLocaleTimeString(undefined, options);
        return <div>{formattedTime}</div>;
      },
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="container">
        <h3 className="table-heading mb-4">Appointments</h3>
        {isLoading ? (
          <Spin
            size="large"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        ) : appointments.length > 0 ? (
          <div className="table-responsive">
            <Table dataSource={appointments} columns={columns} />
          </div>
        ) : (
          <div className="error-message">No appointments</div>
        )}
      </div>
    </div>
  );
};

export default AppointmentsPage;
